<template>
    <div>
        <div class="page">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg>
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li>{{ this.$route.params.name }}</li>
                </ul>
            </nav>
        </div>
        <div class="container" v-html="content"></div>
        <!-- <div>{{ getnav }}</div> -->
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            content: '',
            webmeta: {
                description: '',
                og_description: '',
                og_image: '',
                og_title: '',
                title: ''
            }
        };
    },
    computed: {
        ...mapState('header', ['getnav', 'navcontent', 'getseo']),
        computedWebMeta() {
            if (this.navcontent && this.navcontent.seo) {
                return {
                    description: this.navcontent.seo.description || '',
                    og_description: this.navcontent.seo.og_description || '',
                    og_image: this.navcontent.seo.og_image || '',
                    og_title: this.navcontent.seo.og_title || '',
                    title: this.navcontent.seo.title || ''
                };
            } else {
                return {
                    description: this.getseo.meta_description,
                    og_description: this.getseo.og_description,
                    og_image: this.getseo.og_image,
                    og_title: this.getseo.og_title,
                    title: this.getseo.og_title
                };
            }
        }
    },
    watch: {},
    methods: {
    },
    created() {
    },
    async serverPrefetch() {
        this.$store.getters['header/getnav'].forEach(element => {
            if (this.$route.params.name == element.name) {
                // this.data = element;
                this.$store.commit('header/SET_NAVCONTENT', element)
            }
            // console.log(element);
        });
        // console.log(this.getnav);
        // console.log(this.$route.params.name);
        // console.log(this.$store,'moren');
        // console.log(this.$store.getters['header/getnav'],'getnav');
        // this.$store.getters['header/getnav'].forEach(element => {
        //     // console.log(1);
        //         console.log(element, 'da');
        //     if (this.$route.params.name == element.name) {
        //         // this.data = element;
        //         this.$store.commit('header/SET_GETNAV', element)
        //         console.log(element, 'xiao');
        //     }
        //     // console.log(element);
        // });
        // console.log(this.navcontent,'server');
    },
    metaInfo() {
        return {
            title: this.computedWebMeta.og_title,
            meta: [
                { vmid: 'title', name: 'title', content: this.computedWebMeta.title },
                { vmid: 'description', name: 'description', content: this.computedWebMeta.description },
                { vmid: 'og_title', property: 'og:title', content: this.computedWebMeta.og_title },
                { vmid: 'og_image', property: 'og:image', content: this.computedWebMeta.og_image },
                { vmid: 'og_description', property: 'og:description', content: this.computedWebMeta.og_description },
            ]
        }
    },
    mounted() {
        // console.log(this.$store.getters['header/getnav'],'client');
        // this.getnav.forEach(element => {
        //     console.log(element);
        // });
        // if (this.$route.params.name) {

        // }
        for (const key in this.$store.getters['header/getnav']) {
            if (this.$store.getters['header/getnav'][key].name === this.$route.params.name) {
                // console.log(this.$store.getters['header/getnav'][key]);
                this.content = this.$store.getters['header/getnav'][key].content
                console.log(this.content);

            }
        }
    },
}
</script>
<style lang='scss' scoped>
::v-deep {
    p {
        margin: 0;
    }
}

.container {
    margin: auto;
    padding: 0 15px;
}

.page {
    // position: relative;
    margin-bottom: 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-color: #bbb19e;

    nav {
        max-width: min(100%, 1140px);
        padding: 0 15px;
        margin: 0 auto;

        ul {
            padding: 12px 0;

            li {
                .home {
                    svg {
                        color: #BBB19E;
                        width: 15px;
                    }
                }
            }

            li:not(:first-child) {
                font-size: 13px;
                padding-left: 0.5rem;
                color: #bbb19e;

                &::before {
                    display: inline-block;
                    padding-right: 0.5rem;
                    content: ">";
                    color: #bbb19e;
                }
            }
        }
    }
}

@media (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}

@media (min-width:768px) {
    .container {
        max-width: 720px;
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }

}
</style>